import QueryString from 'qs';
import Defaults from './default';

// mock api
const ROOT_URL = 'http://localhost:3000';
const DEV = {
  ENV: 'dev',
  APIA_ROOT_CONTEXT: '',
  LOGIN_URL: `${ROOT_URL}/login`,
  PASSWORD_CHANGE_REQUEST_URL: `${ROOT_URL}/remember`,
  CHANGE_PWD_URL: `${ROOT_URL}/changePwd`,
  CHANGE_PWD_EXTERNAL_URL: `${ROOT_URL}/changePasswordFromExternal`,
  GOTO_SPLASH_URL: `${ROOT_URL}/gotosplash`,
  PROCESS_FIELD_SUBMIT_URL: `${ROOT_URL}/processFieldSubmit`,
  CHECK_WEB_DAV_DOCUMENTS_LOCKS_URL: `${ROOT_URL}/web-dav`,
  HAS_SIGNABLE_FORMS_URL: () => `${ROOT_URL}/has-signable-forms`,
  CONFIRM_FORM_URL: () => `${ROOT_URL}/confirm`,
  CONFIRM_FORM_POOL: `${ROOT_URL}/confirmPool`,
  CONFIRM_PATH: `${ROOT_URL}/confirmPath`,
  CLEAR_EVAL_PATH: `${ROOT_URL}/clearEvalPath`,
  FORM_CHECK_IF_WIZARD_URL: `${ROOT_URL}/check-if-wizard`,
  FORM_GOTO_NEXT_STEP_URL: () => 'http://127.0.0.1:9000/page.html',
  FORM_GOTO_PREVIOUS_STEP_URL: () => 'http://127.0.0.1:9000/',
  FORM_SUBMIT_FIELD_EVENTS_URL: () => 'http://127.0.0.1:9000/',
  FORM_AJAX_FIELD_EVENTS_URL: `${ROOT_URL}/fireFieldEvent`,
  GRID_PROCESS_FIELD_URL: `${ROOT_URL}/processGridFieldAction`,
  GRID_EDIT_FORM_URL: 'http://127.0.0.1:9000/',
  GET_DOC_TYPE_INFORMATION_URL: `${ROOT_URL}/getDocTypeInformation`,
  DOWNLOAD_DOC_URL: `${ROOT_URL}/`,
  CHECK_LOCK_DOCUMENT_URL: `${ROOT_URL}/checkLockDocument`,
  LOCK_DOCUMENT_URL: `${ROOT_URL}/lockDocument`,
  IS_WEBDAV_DOCUMENT_LOCKED_URL: `${ROOT_URL}/isWebDavDocumentLocked`,
  AJAX_UPLOAD_FILE_START_URL: `${ROOT_URL}/ajaxUploadStart`,
  AJAX_UPLOAD_FILE_URL: `${ROOT_URL}/ajaxUploadFile`,
  AJAX_REMOVE_FILE_URL: `${ROOT_URL}/ajaxRemoveFile`,
  AJAX_UPLOAD_FILE_STATUS_URL: `${ROOT_URL}/ajaxUploadFileStatus`,
  SAVE_TASK_URL: () => `${ROOT_URL}/saveTask`,
  RELEASE_TASK_URL: () => `${ROOT_URL}/release`,
  TREE_IMG_URL: `${ROOT_URL}/Apia/getImage.run?image=`,
  CAPTCHA_IMG_URL: `http://localhost:8080/Apia/captchaImg?captchaName=`,
  CAPTCHA_RELOAD_IMG_URL: `http://localhost:8080/Apia/captchaAudio?captchaName=`,
  CAPTCHA_AUDIO_URL: `http://localhost:8080/Apia/captchaAudio?captchaName=`,

  // SCHEDULE
  SCHEDULE_INITIAL_LOAD: `${ROOT_URL}/apia.design.TaskSchedulerAction.run?action=getExecutionSchedulerWeek`,

  // Apia finder
  FINDER_FIRST_STRUCTURE_LOAD: (ajaxUrl: string) =>
    `${ROOT_URL}/finder/firstStructureLoad?${ajaxUrl}`,
  FINDER_REFRESH_DATA: (ajaxUrl: string) =>
    `${ROOT_URL}/finder/refreshData?${ajaxUrl}`,
  FINDER_SELECT_ROW_GET_DATA: (ajaxUrl: string) =>
    `${ROOT_URL}/finder/selectRowGetData?${ajaxUrl}`,
  FINDER_GET_FILTERS_CONDITIONS: (ajaxUrl: string) =>
    `${ROOT_URL}/finder/getFiltersConditions?${ajaxUrl}`,
  FINDER_CHECK_MODAL_VALUE: () => `${ROOT_URL}/finder/checkModalValue?`,

  // Administration
  ADMIN_GET_PAGE: (pageNumber: number, action = 'page') =>
    `${ROOT_URL}/administration/groups/getPage?${pageNumber}${action}`,
  ADMIN_REFRESH_PAGE: () => `${ROOT_URL}/administration/groups/refreshPage?`,
  ADMIN_MORE_INFO: () => `${ROOT_URL}/administration/groups/moreInfo?`,
  ADMIN_FILTER: (action = 'filter') =>
    `${ROOT_URL}/administration/groups/filter?${action}`,
  ADMIN_CREATE_EXCEL_FILE: () =>
    `${ROOT_URL}/administration/groups/createExcelFile?`,
  ADMIN_DOWNLOAD_LIST: () => `${ROOT_URL}/administration/groups/downloadList?`,
  ADMIN_UPLOAD: () => `${ROOT_URL}/administration/groups/ajaxUploadStart?`,
  ADMIN_UPLOAD_FILE_STATUS: () =>
    `${ROOT_URL}/administration/groups/uploadFileStatus?`,
  ADMIN_SORT: () => `${ROOT_URL}/administration/groups/sort?`,
  ADMIN_CREATE: () => `${ROOT_URL}/administration/groups/create?`,
  ADMIN_UPDATE: (id: number | string) =>
    `${ROOT_URL}/administration/groups/update?id=${id}`,
  ADMIN_GET_ENVIRONMENTS: () =>
    `${ROOT_URL}/administration/groups/getEnvironments?`,
  ADMIN_CONFIRM: () =>
    `${ROOT_URL}/administration/groups/confirm${
      Math.random() * 100 < 20 ? 'Wrong' : 'Ok'
    }?a=${Math.random() * 100}`,
  ADMIN_CANCEL: () => `${ROOT_URL}/administration/groups/cancel?`,
  ADMIN_DELETE: (id: string) =>
    `${ROOT_URL}/administration/groups/delete${
      Math.random() * 100 < 20 ? 'Wrong' : 'Ok'
    }?id=${id}`,
  ADMIN_CLONE: () => `${ROOT_URL}/administration/groups/clone?`,
  ADMIN_LOAD_DEPS: (id: string) =>
    `${ROOT_URL}/administration/groups/loadDeps?id=${id}`,
  ADMIN_DOWNLOAD_DEPS: (id: string) =>
    `${ROOT_URL}/administration/groups/downloadDeps?id=${id}`,
  ADMIN_GET_IMAGES: () => `${ROOT_URL}/administration/getImages?`,

  IMAGE_SELECTOR_DEFAULT_IMAGE:
    'http://localhost:8080/Apia/images/uploaded/-736769579.JPEG',

  TABLE_MODAL_FILTER: (modalClass: string) =>
    `${ROOT_URL}/administration/groups/onAddEnvironment?modalClass=${modalClass}`,
  TABLE_MODAL_PAGE: (modalClass: string, pageNumber: number) =>
    `${ROOT_URL}/administration/groups/environmentPage?modalClass=${modalClass}${pageNumber}`,
  TABLE_MODAL_REFRESH: (modalClass: string) =>
    `${ROOT_URL}/administration/groups/onAddEnvironment?modalClass=${modalClass}`,
  TABLE_MODAL_SORT: (modalClass: string) =>
    `${ROOT_URL}/administration/groups/onAddEnvironment?modalClass=${modalClass}`,

  TOGGLE_FAVORITE: (_ajaxUrl: string, functionId: number) =>
    `${ROOT_URL}/administration/toggleFavorite?id=${functionId}`,

  APIA_URL: (
    ajaxUrl: string,
    action: string,
    etc?: Record<string, unknown> | string,
  ) => {
    const queryString = QueryString.stringify(etc);
    console.log(`${window.CONTEXT}${ajaxUrl}?action=${action}&${queryString}`);
    return `${window.CONTEXT}${ajaxUrl}?action=${action}&${queryString}`;
  },
};

const config = { ...DEV, ...Defaults } as typeof DEV &
  typeof Defaults &
  Record<string, string>;
export default config;
